import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const SupplierType = () => {
  return (
    <SettingsMetaData propertyName={"SupplierType"} viewPropertyName={"Type"} />
  );
};
export default SupplierType;